import { render, staticRenderFns } from "./OrganizationUsersRestoreItem.vue?vue&type=template&id=cf25b896&"
import script from "./OrganizationUsersRestoreItem.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUsersRestoreItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports